export const onExpandHandler = (newState, instance, onExpand) => {
    if (!(instance === null || instance === void 0 ? void 0 : instance.preFilteredFlatRows.length)) {
        onExpand === null || onExpand === void 0 ? void 0 : onExpand([], newState);
        return;
    }
    const expandedData = [];
    instance.preFilteredFlatRows.forEach((row) => {
        if (newState.expanded[row.id]) {
            expandedData.push(row.original);
        }
    });
    onExpand === null || onExpand === void 0 ? void 0 : onExpand(expandedData, newState);
};
